























































































  import { Contract } from '@/entity/Net20/Contract';
  import { STEP_ENUM } from '@/entity/Net20/ContractStep';
  import { ContractWidget } from '@/entity/Net20/ContractWidget';
  import { i18n } from '@/i18n/i18n-setup';
  import { ClaimEnum } from '@/services/ClaimEnum';
  import { General } from '@/services/General';
  import axios from 'axios';
  import { Component, Vue } from 'vue-property-decorator';
  import CustomerDetails from '../CustomerDetails.vue';   
  import ContractStepBack from '../modules/ContractStepBack.vue';
  import { SyncNet20Dropdowns } from '@/services/Net20DropDowns';

  @Component({
      components: {
          CustomerDetails,
          ContractStepBack
      }
  })
  export default class PendingContractsWidget extends Vue {
      loading: boolean = false;
      page: number = 1;
      resultsItems: any = {
          resultPage: new Array<ContractWidget>(),
          total: 0
      };
      selectedContract: Contract = null;  
      selectedContractId: string = '';
      selectedContractYear: number = 0;
      idCustomerDetail: string = '';
      numericIdSelected: number = 0;
      customerDetailModalTitle: string = '';
      
      adminUtilsReady: boolean = false;
      contractStepBackVisibility: boolean = false;
      
      async mounted() {
          await this.searchContractsWidgetInfo(false);
          await SyncNet20Dropdowns(); 
      }

      afterContractStepBack() {
          this.$bvModal.hide('contractStepBackModal');        
          this.$bvModal.hide('customer-details-modal');
          this.postUpdatingCustomer();
      }

      openCustomer(contract: ContractWidget = null) {
          this.adminUtilsReady = false;
          if(contract != null) {
              this.selectedContractYear = contract.contractYear;
              this.selectedContractId = contract.id;
              this.idCustomerDetail = contract.idCustomer;
              this.numericIdSelected = contract.numericId;
              this.customerDetailModalTitle = `${i18n.t('NET20.CUSTOMER') as string}: ${this.numericIdSelected}`;
          }

          this.$bvModal.show('customer-details-modal');
      }

      async postUpdatingCustomer() {
          this.resultsItems = {
              resultPage: new Array<ContractWidget>(),
              total: 0
          };
          await this.searchContractsWidgetInfo(false, true);
      }

      async searchContractsWidgetInfo(switchPage: boolean, resetPagination: boolean = false) {
          this.loading = true;

          if(resetPagination) {
              this.page = 1;
          }
          else {
              if(switchPage)
                  this.page = this.page + 1;
          }

          try {
              let results: any = await axios({
                  method: 'post',
                  url: General.GetApiUrl('/api/net20/GetContractsWidgetInfoWithFilter'),
                  data: {
                      CurrentPage: this.page,
                      PageSize: 4
                  },
                  withCredentials: true,
                  responseType: 'json'
              });
             
              this.resultsItems.resultPage = this.resultsItems.resultPage.concat(results.data.listPage);
              this.resultsItems.total = results.data.total;

              this.syncPendingContracts();
              this.loading = false;
          } catch (error) {
              General.HandleError(error, this);
              this.loading = false;
          }
      }

      syncPendingContracts() {
          this.$emit("pending-contracts-sync", this.resultsItems.total);
      }

      async markAsRead(contract:ContractWidget){   
          General.confirm((i18n.t('NET20.CUSTOMER_NUMERIC_ID') as string) +contract.numericId,this,async ()=> {
              await axios({
                  method: 'put',
                  url: General.GetApiUrl('/api/net20/MarkContractAsRead'),
                  params: {
                      idContract: contract.id
                  
                  },
                  withCredentials: true,                    
              });
              
              await this.postUpdatingCustomer();
          })    
      }

      async markAllAsRead(){
          General.confirm((i18n.t('NET20.MARK_ALL_AS_READ_CONFIRM') as string),this,async ()=> {
              await axios({
                  method: 'put',
                  url: General.GetApiUrl('/api/net20/MarkAllContractAsRead'),
                  
                  withCredentials: true,                    
              });
              
              await this.postUpdatingCustomer();
          })
      }

      isAdminUtilsVisible() {
          let check = false;
          let isAdminNet20 = General.CheckAuthorization(ClaimEnum.CanAdminNet20);
          if(isAdminNet20 && this.adminUtilsReady) {
              if(this.contractStepBackVisibility) {
                  check = true;
              }
          }
          return check;
      }

      onSelectingContract(contractSelected, isRenewal) {
          this.adminUtilsReady = true;
          this.selectedContractId = contractSelected.id;
          this.selectedContract = contractSelected;

          if(isRenewal || this.selectedContract.idStep == STEP_ENUM.EVALUATION_FORM)
              this.contractStepBackVisibility = false;
          else
              this.contractStepBackVisibility = true;
      }

      onCustomerDetailExecutingAction() {
          this.adminUtilsReady = false;
      }

      close() {
          this.$bvModal.hide('customer-details-modal');
      }
}
